var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"var(--dark)"}},[_c('b-container',[_c('div',{staticClass:"p-1"},[_c('b-alert',{staticStyle:{"width":"100%"},attrs:{"show":"","dismissible":"","variant":"info"}},[_c('b-icon',{attrs:{"icon":"bell"}}),_vm._v("  "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$store.state.config.announcement)}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }